import { render, staticRenderFns } from "./rates.vue?vue&type=template&id=fb6f6402&scoped=true"
import script from "./rates.vue?vue&type=script&lang=js"
export * from "./rates.vue?vue&type=script&lang=js"
import style0 from "./rates.vue?vue&type=style&index=0&id=fb6f6402&prod&lang=scss&scoped=true"
import style1 from "./rates.vue?vue&type=style&index=1&id=fb6f6402&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6f6402",
  null
  
)

export default component.exports